import React, { Component } from 'react'

export default class DetailButton extends Component {
    detailitem(){
        this.props.detail(this.props.value)
    }
    render() {
        if (this.props.value!==null && this.props.value!==undefined){
            return (
                <div onClick={this.detailitem.bind(this)} className="myLink">جزئیات</div>
            )   
        }else{
            return(null)
        }
        
    }
}
